import { useQuery } from '@tanstack/react-query'

import { apiFetch } from './apiFetch'

export const useHtmls = (projectId) =>
  useQuery({
    queryKey: ['htmls', projectId],
    queryFn: () => apiFetch(`/api/user/projects/${projectId}/htmls`),
    enabled: !!projectId,
    retry: false,
  })
